import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import VelocityMix from './Charts/Pricing/VelocityMix';
import ProfitEatingOrders from './Charts/Pricing/ProfitEatingOrders';
import LowMarginLowVolume from './Charts/Pricing/LowMarginLowVolume';
import ChartTabs from '../Common/ChartTabs';  
import LowMargin from './Charts/Pricing/LowMargin';
import MarginsBySKU from './Charts/Pricing/MarginsBySKU';
// import BelowMinimumThreshold from './Charts/Pricing/BelowMinimumThreshold';
export default function Pricing(props: { id: number, height: number }) {
  return (
    <Box sx={{ width: '100%', typography: 'body1', height: 'auto', margin: '-25px 0 0 0', padding: 0 }}>
      <ChartTabs tabs={[
        <Tab wrapped style={{ textTransform: 'capitalize' }} label="Low Margin Low Volume" value="0" />,
        // <Tab wrapped style={{ textTransform: 'capitalize' }} label="Below Minimum Margin" value="1" />,
        <Tab wrapped style={{ textTransform: 'capitalize' }} label="Velocity Mix" value="1" />,
        <Tab wrapped style={{ textTransform: 'capitalize' }} label="Low Margin Orders" value="2" />,
        <Tab wrapped style={{ textTransform: 'capitalize' }} label="Margins by SKU" value="3" />,
        // <Tab wrapped style={{ textTransform: 'capitalize' }} label="Price Mode" value="2" />,
        // <Tab wrapped style={{ textTransform: 'capitalize' }} label="Profit Eating Accounts" value="2" />,
      ]} values={["0", "1", "2", "3"]} ariaLabel="Customer pricing tabs" panels={[
        <LowMarginLowVolume title="Low Margin Low Volume" id={props.id} height={props.height} />,
        // <BelowMinimumThreshold title="Below Minimum Margin" />,
        <VelocityMix title="Velocity Mix" id={props.id} height={props.height} />,
        <LowMargin title="Low Margin Orders" id={props.id} height={props.height} />,
        <MarginsBySKU title="Margins by SKU" id={props.id} height={props.height} />,
      ]} />
    </Box>
  );
}
